export default __webpack_public_path__ + "static/firstimpression-8e0227cd0594f79f2fb03c177efb681b.webp";